import{connect}from'react-redux';import{getPreferredLocationAddress}from"../../selectors";/**
 * @returns {Function}
 */function makeMapStateToProps(){return function(state){return{userLocation:getPreferredLocationAddress(state)};};}export default connect(makeMapStateToProps);